import React, {useCallback} from "react";
import useForm from "rc-form-hooks";
import Input from "../../components/inputItem";
import {postUserNameModify} from "../../service";
import {useHistory} from "react-router-dom";
import {useLoading} from "../../components/loading/LoadingProvider";
import useUserInfo from "../../routers/useUserInfo";
import {useDispatch} from "react-redux";
import {userInfoAction} from "../../store/actions";


function UserInfoInputRealName() {

    const {getFieldDecorator, validateFields, errors, values} = useForm<{
        name: string
    }>();

    const userData = useUserInfo();
    const loading = useLoading()
    const { goBack } = useHistory()
    const dispatch = useDispatch()

    const handleSubmit = useCallback((e: React.FormEvent) => {
        e.preventDefault();
        validateFields()
            .then(res => {
                if (userData && typeof values.name === 'string') {
                    postUserNameModify({
                        userId: userData.id,
                        name: values.name
                    }).then(res => {
                        if (res.code === 1) {
                            loading.showSuccess('操作成功',() => {
                                goBack()
                            })
                            dispatch(userInfoAction(Object.assign({},userData,{fullName:values.name})))
                        }else{
                            loading.showError(res.msg)
                        }
                    })
                }

            })
            .catch(e => console.error(e.message));
    }, [values])

    return <div className="user-nickname">
        <form onSubmit={handleSubmit}>
            {
                getFieldDecorator('name', {
                    rules: [{required: true, message: '请输入真实姓名'}],
                })(<Input label='真实姓名' type={'text'} placeholder='请输入真实姓名'
                          extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }
            {
                userData && <button type={'submit'} className="common-btn submit">确认</button>
            }

        </form>
    </div>
}

export default UserInfoInputRealName;
